import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { getServices } from "../../../utils/cms.utils";
import icons from "../../../utils/constant/icon.generated.json";

const Services = () => {
    const [services, setServices] = useState([]);

    /* ================= LOAD CMS ================= */
    useEffect(() => {
        const data = getServices();
        setServices(Array.isArray(data) ? data : []);
    }, []);

    /* ================= SORT ONCE ================= */
    const sortedServices = useMemo(() => {
        return [...services].sort(
            (a, b) => (a.orderNo ?? 0) - (b.orderNo ?? 0)
        );
    }, [services]);

    const slideControl = {
        spaceBetween: 25,
        slidesPerView: 4,
        speed: 1000,
        loop: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".service_next",
            prevEl: ".service_prev",
        },
        breakpoints: {
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1025: { slidesPerView: 4 },
        },
    };

    if (!sortedServices.length) return null;

    return (
        <section className="services__one section-padding">
            <div className="container">

                {/* ===== HEADER ===== */}
                <div className="row al-end">
                    <div className="col-lg-8 mt-3 text-center mx-auto w-100">
                        <div className="services__one-title lg-t-center lg-mb-20">
                            <span className="subtitle">Our Services</span>
                            <h2>Provide Quality Services</h2>
                        </div>
                    </div>

                    <div className="col-lg-4 w-100 mx-auto">
                        <div className="slider-arrow jc-end lg-jc-center mb-10">
                            <div className="slider-arrow-prev service_prev">
                                <i className="fa-regular fa-arrow-left-long"></i>
                            </div>
                            <div className="slider-arrow-next service_next">
                                <i className="fa-regular fa-arrow-right-long"></i>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ===== SLIDER ===== */}
                <div className="row mt-60">
                    <div className="col-xl-12 swiper-area">
                        <Swiper modules={[Autoplay, Navigation]} {...slideControl}>
                            {sortedServices.map((service) => {
                                const iconSrc = icons[service.icon];

                                return (
                                    <SwiperSlide key={service.id}>
                                        <div className="services__card">

                                            {/* ICON */}
                                            <div className="service-icon">
                                                {iconSrc ? (
                                                    <span
                                                        className="icon-preview"
                                                        style={{
                                                            backgroundImage: `url(${iconSrc})`,
                                                        }}
                                                        role="img"
                                                        aria-label={service.titleEn}
                                                    />
                                                ) : (
                                                    <span
                                                        className="icon-missing"
                                                        title="Icon not found"
                                                    >
                                                        ?
                                                    </span>
                                                )}
                                            </div>

                                            {/* CONTENT */}
                                            <div className="services__card-content">
                                                <h4>
                                                    <Link to={`/services/${service.id}`}>
                                                        {service.titleEn}
                                                    </Link>
                                                </h4>

                                                {service.titleId && (
                                                    <p className="services__card-subtitle">
                                                        {service.titleId}
                                                    </p>
                                                )}
                                            </div>

                                            {/* CTA */}
                                            <Link
                                                to={`/services/${service.id}`}
                                                className="services__card-link"
                                            >
                                                Read More <i className="flaticon-right-up"></i>
                                            </Link>

                                        </div>
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default Services;
